const initialState = {
  status: "invalid",
};

function SettingsReducer(state = initialState, action) {
  switch (action.type) {
    case "SETTINGS_LOADING":
      return {
        ...state,
        status: "loading",
      };
    case "SETTINGS_SUCCESS":
      return {
        ...state,
        status: "success",
        data: action.data,
      };
    case "SETTINGS_FAILURE":
      return {
        ...state,
        status: "failure",
        err: action.err,
      };
    default:
      return state;
  }
}

export default SettingsReducer;
